import React from "react";
import ModalWindow from "../Shared/ModalWindow";

export default class InputModal extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "commentEdit": null
        };

    }

    componentDidUpdate (prevProps) {

        if (this.props.comment !== prevProps.comment) {

            this.handleOnClickCancel();

        }

    }

    handleOnChangeText (event) {

        this.setState({
            "commentEdit": event.target.value
        });

    }

    handleOnClickCancel () {

        this.setState({
            "commentEdit": null
        });

    }

    render () {

        const comment = this.state.commentEdit !== null ? this.state.commentEdit : this.props.comment !== null ? this.props.comment : "Add comment...", // Todo: add text to comment store

            confirmBody =
                (<div>
                 <textarea className="form-control"
onChange={(e) => this.handleOnChangeText(e)}
value={comment} />
                <button
className="btn btn-danger modalButton"
                    data-dismiss="modal"
                     onClick={() => this.props.onClickSave(comment)}
                >
Save
                </button>
                 <button
className="btn btn-secondary modalButton"
                    data-dismiss="modal"
                     href={`#${  this.props.modalId}`}
                     onClick={() => this.handleOnClickCancel()}
                >
Cancel
                </button>

             </div>);

        return (
            <ModalWindow
                modalBody={confirmBody}
                modalId={this.props.modalId}
                modalTitle={this.props.modalTitle}
            />
        );

    }

}
